export const DEFAULT_SUPPORT_PORTAL_URL =
  'https://blocktickets-team.atlassian.net/servicedesk/customer/portal/67'

export const JSD_WIDGET_BASE_URL = 'https://jsd-widget.atlassian.com'
export const JSD_WIDGET_SCRIPT_SRC = `${JSD_WIDGET_BASE_URL}/assets/embed.js`
export const JSD_WIDGET_SCRIPT_ID = 'jsd-widget-embed-script'
export const JSD_WIDGET_IFRAME_ID = 'jsd-widget'

export const SUPPORT_PANEL_ID = 'support-widget-panel'
export const SUPPORT_TRIGGER_ID = 'support-widget-trigger'
export const SUPPORT_SHORTCUT_HINT = 'Shift+/'

// Routes where a floating overlay would conflict with auth, onboarding, or
// kiosk-style screens. Prefix match covers nested paths like /login/forgot-password.
export const HIDDEN_PATH_PREFIXES = [
  '/login',
  '/register',
  '/signup',
  '/fulfillment',
]

export const IFRAME_LOAD_TIMEOUT_MS = 8000

/**
 * The official JSM embed (`jsd-widget.atlassian.com`) is designed to run on
 * third-party origins. The customer portal at
 * blocktickets-team.atlassian.net still sets CSP frame-ancestors that exclude
 * BlockTickets admin hosts, so the portal iframe fallback may continue to
 * open in a new tab until that allowlist includes our domains.
 */
export const SUPPORT_EMBED_RESTRICTION =
  'Jira Service Management sets CSP frame-ancestors that exclude BlockTickets admin hosts, so the portal cannot be embedded from this application.'
